const initialState = { 
  loading: false,
  success: null,
  error: null
}

function updateProductReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_PRODUCT_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'UPDATE_PRODUCT_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'UPDATE_PRODUCT_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default updateProductReducer